<h3>Dialer Firmware Management</h3>
<div class="information_div_style">
  <p>This page allows the user to perform different actions regarding the firmware of the dialers. The following points should be considered:</p>
  <ul>
    <li>First, be sure you are selecting the correct <b>enviroment</b> (Dev, Stable or Production) in the stage section above.</li>
    <li>You must select the dialer type and the model or models you are going to use in the different options.</li>
  </ul>
  <p>These are the actions you can execute in this page:</p>
  <ul>
    <li><b>Upload new firmware:</b> Once you have selected the device type, vendor and model/s, you need to add the .bin file with the firmware</li>
    <li><b>Assign a new default firmware version to a dialer type:</b> it will set a new default firmware for a specific combination of:</li>
    <li class="hide_bullet_point">
      <ul>
        <li>Dialer type</li>
        <li>Vendor</li>
        <li>Model/s version/s</li>
        <li>RegulatoryCode (not Family or Bundle!)</li>
      </ul>
    </li>
  </ul>
</div>
<h2>** Select device type, vendor and model/s</h2>
<div class="custom_div_style">
  <div>
    <span class="custom_span_mat_select_style">Select Device Type:</span>
    <br />
    <mat-form-field floatLabel="auto">
      <mat-select class="form-control mat-select_custom_style"
        [(ngModel)]="selectedDeviceType"
        (selectionChange)="deviceTypeChange()"
        placeholder="Select device type">
        @for (eItem of deviceTypes; track eItem) {
          <mat-option [value]="eItem">
            {{eItem}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <span class="custom_span_mat_select_style">Vendor:</span>
    <br />
    <mat-form-field floatLabel="auto">
      <mat-select class="form-control mat-select_custom_style"
        [(ngModel)]="selectedVendor"
        (selectionChange) ="onVendorChange()"
        placeholder="Select vendor">
        @for (item of availableVendors; track item) {
          <mat-option [value]="item">
            {{item}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <span class="custom_span_mat_select_style">Select Model:</span>
    <br />
    <mat-form-field [matTooltip]="getToolTipModelsSelected()"
      [matTooltipShowDelay]="300"
      floatLabel="auto">
      <mat-select class="form-control mat-select_custom_style"
        [(ngModel)]="selectedModelNumbers"
        multiple
        placeholder="Select model"
        (closed)="onModelSelectorClosed()">
        <mat-select-trigger>
          <ng-container>
            {{ getModelText() }}
          </ng-container>
        </mat-select-trigger>
        @for (eItem of modelNumbers; track eItem) {
          <mat-option [value]="eItem">
            {{eItem}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
<h2>Upload new Firmware Image</h2>
<div class="custom_div_style">
  <input #firmwareFileinput type="file" required
    class="form-control input_file_style"
    accept=".bin"
    (change)="onFileChange($event)"/>
    <button type="button"
      class="btn button-fix button-color-fix-purple"
      (click)="uploadFirmwareFile()">
      Upload <mat-icon class="icon-color-fix" style="margin-left:4px">cloud_upload</mat-icon>
    </button>
  </div>
  <br />
  <h2>Set Default Firmware</h2>
  <div class="custom_div_style">
    <div>
      <span class="custom_span_mat_select_style">Select Regulatory Code Family:</span>
      <br />
      <mat-form-field floatLabel="auto">
        <mat-select class="form-control mat-select_custom_style"
          [(ngModel)]="selectedRegulatoryCode"
          (selectionChange)="regulatoryCodeChange()"
          placeholder="Select Regulatory Code">
          @for (item of availableRegulatoryCodes; track item) {
            <mat-option [value]="item">
              {{item}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <span class="custom_span_mat_select_style">Current default FW:</span>
      <br />
      <mat-form-field floatLabel="auto">
        <input matInput
          class="form-control mat-select_custom_style textbox-label"
          [value]="defaultFW"
          readonly
          disabled />
      </mat-form-field>
    </div>
    <div>
      <span class="custom_span_mat_select_style">Select Firmware version:</span>
      <br />
      <mat-form-field floatLabel="auto">
        <mat-select class="form-control mat-select_custom_style"
          [(ngModel)]="selectedFirmwareVersion"
          placeholder="Select version">
          @for (item of availableFirmwareVersions; track item) {
            <mat-option [value]="item">
              {{item}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="button_div_style">
      <div class="button_div_style_row">
        <button type="button"
          mat-raised-button class="btn button-fix button-color-fix-purple"
          (click)="setDefaultVersion()"
          [disabled]="isSettingDefaultFirmware || isSetDefaultDisabled()"
          [matTooltip]="getSetDefaultFirmwareTip()">
          Make default version <mat-icon class="icon-color-fix">save_alt</mat-icon>
        </button>
        @if (isSettingDefaultFirmware && !statusDialogRef) {
          <button mat-raised-button
            class="btn button-fix button-color-fix-green"
            (click)="openStatusDialog()">
            Running Status
          </button>
        }
      </div>
    </div>
  </div>